export default __webpack_public_path__ + "static/media/2.07b79ef2.webp";